// Studio Laetitia — nav, colour filters, PDP variants, cart drawer.
(function(){
  // ---- mobile nav ----
  document.addEventListener('click', function(e){
    const t = e.target.closest('.nav-toggle');
    if(!t) return;
    const nav = t.closest('.nav');
    const open = nav.classList.toggle('open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // ---- collection colour filter ----
  const bar = document.querySelector('.filter-bar .filters');
  const grid = document.querySelector('.pg-grid');
  if(bar && grid){
    const buttons = Array.prototype.slice.call(bar.querySelectorAll('button'));
    function apply(label){
      const key = label.trim().toLowerCase();
      grid.querySelectorAll('.product-card').forEach(function(card){
        const list = (card.dataset.colours || '').toLowerCase();
        card.classList.toggle('is-hidden', key !== 'all' && list.indexOf(key) === -1);
      });
      const shown = grid.querySelectorAll('.product-card:not(.is-hidden)').length;
      let empty = grid.parentNode.querySelector('.filter-empty');
      if(!empty){ empty = document.createElement('p'); empty.className = 'filter-empty'; grid.after(empty); }
      empty.textContent = shown ? '' : ((window.SL_T||{}).empty||'Nothing in that colour yet.');
      empty.style.display = shown ? 'none' : 'block';
    }
    bar.addEventListener('click', function(e){
      const b = e.target.closest('button');
      if(!b) return;
      buttons.forEach(function(x){ x.classList.remove('active'); });
      b.classList.add('active');
      apply(b.classList.contains('active') && b === buttons[0] ? 'all' : b.textContent);
    });
  }

  // ---- PDP ----
  const pdp = document.querySelector('[data-pdp]');
  if(pdp){
    const dataEl = document.getElementById('pdp-variants');
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const idInput = pdp.querySelector('input[name="id"]');
    const priceEl = pdp.querySelector('[data-pdp-price]');
    const pickedEl = pdp.querySelector('.opt .picked');
    const addBtn = pdp.querySelector('.add-btn');
    const moneyFmt = pdp.dataset.moneyFormat || '€ {{amount}}';

    function money(cents){
      const v = (cents/100).toFixed(2).replace('.', ',').replace(',00','');
      return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
    }
    function select(colour){
      const v = variants.filter(function(x){ return x.option === colour; })[0];
      if(!v) return;
      if(idInput) idInput.value = v.id;
      if(priceEl) priceEl.innerHTML = '<em>' + money(v.price) + '</em>';
      if(pickedEl) pickedEl.textContent = colour;
      if(addBtn){
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? ((window.SL_T||{}).add||'Add to bag') + ' — ' + money(v.price) : ((window.SL_T||{}).sold||'Sold out');
      }
      pdp.querySelectorAll('.sw').forEach(function(b){ b.classList.toggle('active', b.dataset.colour === colour); });
      if(!pdp.dataset.hasPhotos){
        pdp.querySelectorAll('[data-candle-mount]').forEach(function(el){
          window.SL_mountCandle(el, window.SL_motifFor(el), colour);
        });
      }
      const u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(null, '', u);
    }
    pdp.addEventListener('click', function(e){
      const b = e.target.closest('.sw');
      if(b) select(b.dataset.colour);
    });

    const qty = pdp.querySelector('.qty');
    if(qty){
      const span = qty.querySelector('span');
      const field = pdp.querySelector('input[name="quantity"]');
      let n = 1;
      function setQ(v){ n = Math.max(1, v); span.textContent = n; if(field) field.value = n; }
      qty.querySelector('.minus').addEventListener('click', function(){ setQ(n-1); });
      qty.querySelector('.plus').addEventListener('click', function(){ setQ(n+1); });
    }
    pdp.querySelectorAll('.pdp-thumbs .t').forEach(function(t){
      t.addEventListener('click', function(){
        pdp.querySelectorAll('.pdp-thumbs .t').forEach(function(x){ x.classList.remove('active'); });
        t.classList.add('active');
        const src = t.dataset.full;
        const main = pdp.querySelector('[data-pdp-main-image]');
        if(src && main) main.src = src;
      });
    });
  }

  // ---- cart drawer ----
  const drawer = document.getElementById('cart-drawer');
  function openDrawer(){ if(drawer){ drawer.classList.add('open'); document.body.classList.add('drawer-open'); } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('open'); document.body.classList.remove('drawer-open'); } }

  function fmt(cents, fmtStr){
    const v = (cents/100).toFixed(2).replace('.', ',').replace(',00','');
    return (fmtStr || '€ {{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  function renderCart(cart){
    if(!drawer) return;
    const f = drawer.dataset.moneyFormat;
    const body = drawer.querySelector('[data-cart-body]');
    const count = document.querySelectorAll('[data-cart-count]');
    count.forEach(function(el){ el.textContent = cart.item_count; });
    drawer.querySelector('[data-cart-total]').textContent = fmt(cart.total_price, f);
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    if(cart.item_count === 0){
      body.innerHTML = '<p class="cd-empty">' + ((window.SL_T||{}).bag_empty||'Your bag is empty.') + '</p>';
      return;
    }
    body.innerHTML = cart.items.map(function(it){
      return '<div class="cd-item" data-key="' + it.key + '">'
        + '<div class="cd-thumb">' + (it.image ? '<img src="' + it.image + '" alt=""/>' : '') + '</div>'
        + '<div class="cd-meta">'
        +   '<a href="' + it.url + '">' + it.product_title + '</a>'
        +   '<div class="cd-opt">' + (it.variant_title || '') + '</div>'
        +   '<div class="cd-qty"><button data-cd-minus>−</button><span>' + it.quantity + '</span><button data-cd-plus>+</button></div>'
        + '</div>'
        + '<div class="cd-line">' + fmt(it.line_price, f) + '</div>'
        + '</div>';
    }).join('');
  }

  function getCart(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }); }
  function change(key, quantity){
    return fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:quantity})
    }).then(function(r){ return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-open]')){ e.preventDefault(); getCart().then(renderCart).then(openDrawer); return; }
    if(e.target.closest('[data-cart-close]') || e.target.classList.contains('cd-scrim')){ closeDrawer(); return; }
    const minus = e.target.closest('[data-cd-minus]');
    const plus = e.target.closest('[data-cd-plus]');
    if(minus || plus){
      const item = (minus || plus).closest('.cd-item');
      const q = parseInt(item.querySelector('.cd-qty span').textContent, 10);
      change(item.dataset.key, plus ? q + 1 : q - 1);
    }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });

  // add to cart
  document.addEventListener('submit', function(e){
    const form = e.target.closest('form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    const btn = form.querySelector('.add-btn');
    const label = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = ((window.SL_T||{}).adding||'Adding…'); }
    fetch('/cart/add.js', {
      method:'POST', headers:{'Accept':'application/json'}, body: new FormData(form)
    }).then(function(r){ return r.json(); }).then(function(){
      return getCart().then(renderCart).then(openDrawer);
    }).catch(function(){
      window.location.href = '/cart';
    }).then(function(){
      if(btn){ btn.disabled = false; btn.textContent = label; }
    });
  });

  if(drawer) getCart().then(renderCart);
})();
